/**
     * Set cookie into the document
     * @param name Name of the cookie.
     * @param value Value of the cookie.
     * @param days Days until cookie expires.
     */
export function setCookie(name, value, days) {
    let expires = '';
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
    }
    document.cookie =
        name +
        '=' +
        value +
        expires +
        `; domain=${
            window.location.href.includes('localhost')
                ? 'localhost'
                : 'aumee.net'
        }; path=/`;
}

/**
 * Get cookie from document.
 * @param name Name of the cookie to get.
 * @returns Cookie value.
 */
export function getCookie(name) {
    const nameEQ = name + '=';
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i];
        while (cookie.charAt(0) == ' ') {
            cookie = cookie.substring(1, cookie.length);
        }
        if (cookie.indexOf(nameEQ) == 0) {
            return cookie.substring(nameEQ.length, cookie.length);
        }
    }
    return null;
}

/**
 * Delete a cookie from document.
 * @param name Cookie name
 */
export function deleteCookie(name) {
    if (AumeeClient.getCookie(name)) {
        document.cookie =
            name +
            '=' +
            `;expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=${
                window.location.href.includes('localhost')
                    ? 'localhost'
                    : 'aumee.net'
            }; path=/`;
    }
}